import script from "./ClearmentSchutz.vue?vue&type=script&setup=true&lang=js"
export * from "./ClearmentSchutz.vue?vue&type=script&setup=true&lang=js"

import "./ClearmentSchutz.vue?vue&type=style&index=0&id=361e9a82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-361e9a82"]])

export default __exports__